import ENV from "./env"

export const DEXI_UPDATE_TOKEN_FULL_PRICE = 49.95
export const DEXI_UPDATE_TOKEN_DISCOUNT_PRICE = 2
export const DEXI_SUBSCRIBE_FULL_PRICE = 5

// We consider this L1 token (Ar)
export const L1_AR = "0".repeat(43)
export const AO = "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc"
export const WUSDC = "7zH9dlMNoxprab9loshv3Y7WG45DOny_Vrq9KrXObdQ"

export const TOKEN_MIRRORS: Record<string, string> = {
  [AO]: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
}

interface PaymentToken {
  value: string
  label: string
  denomination: number
  logo: string
  disabled?: boolean
}

export const PAYMENT_TOKENS: PaymentToken[] = [
  {
    value: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
    label: "AO",
    denomination: 12,
    logo: "UkS-mdoiG8hcAClhKK8ch4ZhEzla0mCPDOix9hpdSFE",
    disabled: false,
  },
  {
    value: ENV.VITE_WRAPPED_AR_PROCESS,
    label: "wAR",
    denomination: 12,
    logo: "L99jaxRKQKJt9CqoJtPaieGPEhJD3wNhR4iGqc8amXs",
    disabled: false,
  },
  {
    value: ENV.VITE_QAR_PROCESS,
    label: "qAR",
    denomination: 12,
    logo: "26yDr08SuwvNQ4VnhAfV4IjJcOOlQ4tAQLc1ggrCPu0",
    disabled: false,
  },
]

export const NATIVE_TOKENS = [
  {
    TokenProcess: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
    Ticker: "AO",
    Name: "AO",
    Denomination: 12,
    Logo: "UkS-mdoiG8hcAClhKK8ch4ZhEzla0mCPDOix9hpdSFE",
    InternalId: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
    Deployer: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
    Description: "",
    Balances: {},
    TotalSupply: 0,
    Status: "DEPLOYED",
    LPs: {},
    RenounceOwnership: false,
    SocialLinks: [],
    CoverImage: "",
  },
  {
    TokenProcess: "xU9zFkq3X2ZQ6olwNVvr1vUWIjc3kXTWr7xKQD6dh10",
    Ticker: "wAR",
    Name: "wAR",
    Denomination: 12,
    Logo: "L99jaxRKQKJt9CqoJtPaieGPEhJD3wNhR4iGqc8amXs",
    InternalId: "xU9zFkq3X2ZQ6olwNVvr1vUWIjc3kXTWr7xKQD6dh10",
    Deployer: "xU9zFkq3X2ZQ6olwNVvr1vUWIjc3kXTWr7xKQD6dh10",
    Description: "",
    Balances: {},
    TotalSupply: 0,
    Status: "DEPLOYED",
    LPs: {},
    RenounceOwnership: false,
    SocialLinks: [],
    CoverImage: "",
  },
  {
    TokenProcess: "NG-0lVX882MG5nhARrSzyprEK6ejonHpdUmaaMPsHE8",
    Ticker: "qAR",
    Name: "qAR",
    Denomination: 12,
    Logo: "26yDr08SuwvNQ4VnhAfV4IjJcOOlQ4tAQLc1ggrCPu0",
    InternalId: "NG-0lVX882MG5nhARrSzyprEK6ejonHpdUmaaMPsHE8",
    Deployer: "NG-0lVX882MG5nhARrSzyprEK6ejonHpdUmaaMPsHE8",
    Description: "",
    Balances: {},
    TotalSupply: 0,
    Status: "DEPLOYED",
    LPs: {},
    RenounceOwnership: false,
    SocialLinks: [],
    CoverImage: "",
  },
]
export const FORMAT_DECIMALS = 3
export const INPUT_DECIMALS = 6
export const PRICE_DECIMALS = 18

export const REFRESH_INTERVAL = 60_000

export const HOT_AGENT_PERIOD = 5 * 60 * 1000 // 5min
export const HOT_AGENT_REFRESH_INTERVAL = 5 * 1000 // 5sec

export type TimeoutConfig = {
  maxTries: number
  initialDelay: number
}

export const QUICK_OPERATION: TimeoutConfig = {
  maxTries: 5,
  initialDelay: 1_000,
}

export const NORMAL_OPERATION: TimeoutConfig = {
  maxTries: 1000,
  initialDelay: 2_000,
}

export const LONG_OPERATION: TimeoutConfig = {
  maxTries: 1000,
  initialDelay: 3_000,
}

export const QUOTE_TOKENS = [ENV.VITE_QAR_PROCESS, ENV.VITE_WRAPPED_AR_PROCESS, AO]

export const TOKEN_INFO_TIMEOUT = 5000
export const TOKEN_BALANCE_TIMEOUT = 99999999999999 //5000
export const NO_TIMEOUT = 99999999999999

export const DEFAULT_GET_OVERVIEW_HB =
  "https://tee-1.forward.computer/oQZQd1-MztVOxODecwrxFR9UGUnsrX5wGseMJ9iSH38"

export const DEFAULT_TOKENS_HB =
  "https://tee-1.forward.computer/GksVb7A9hrVOKj_tkNJjUQFTNrYwMLIF0-JJOj8APAg"
